import React from "react";

import { Typography, Grid } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import AlgaIcon from "components/libComponents/AlgaTooltips/AlgaIcon";

const useStyles = makeStyles()((theme) => ({
  onboardingInfoBox: {
    gap: theme.spacing(2),
    borderRadius: theme.spacing(1),
    padding: theme.spacing(8, 2, 4, 2),
    border: `1px solid ${theme.palette.primary.main}`,
    textAlign: "center",
    position: "relative",
    // mirrors the alga img position
    marginTop: theme.spacing(10),

    "& > h1": {
      marginBottom: theme.spacing(2),
    },

    "& > img": {
      position: "absolute",
      top: theme.spacing(-10),
    },
  },
}));

export const OnboardingInfoBox = ({
  title,
  body,
  variant,
}: OnboardingInfoBoxProps) => {
  const { classes } = useStyles();

  return (
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      className={classes.onboardingInfoBox}
    >
      <AlgaIcon variant={variant} size="large" />
      <Typography color="primary" variant="h2" component="h1">
        {title}
      </Typography>
      {body.map((paragraph) => (
        <Typography variant="body1" key={paragraph}>
          {paragraph}
        </Typography>
      ))}
    </Grid>
  );
};

/**
 * Props for the onboarding information box component.
 *
 * This interface defines the properties accepted by the OnboardingInfoBox component.
 *
 * @example
 * // Example usage of the OnboardingInfoBoxProps property
 * const infoBoxProps: OnboardingInfoBoxProps = {
 *   title: "Welcome!",
 *   body: "You are about to start your journey.",
 *   variant: "info",
 * };
 */
export type OnboardingInfoBoxProps = {
  /**
   * The title of the information box.
   */
  title: string;

  /**
   * The body or content of the information box.
   */
  body: Array<string>;

  /**
   * The variant of the seaweed image in the information box. It can be "success" for green seaweed,
   * "info" for yellow seaweed, or "error" for red seaweed.
   */
  variant: "success" | "info" | "error";
};
